import { render, staticRenderFns } from "./ScreenDisplay.vue?vue&type=template&id=99a1c00c&scoped=true&"
import script from "./ScreenDisplay.vue?vue&type=script&lang=ts&"
export * from "./ScreenDisplay.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99a1c00c",
  null
  
)

export default component.exports